'use strict';

import '../addons/url.polyfill';
import { PostManager } from '../components/PostManager';
import { LadderLinker } from '../components/LadderLinker';
import { BrowserNotification } from '../components/BrowserNotification';
import './bugPageEvents';

import 'pages/index';
import { Request } from 'components/Request';
import { copyToClipboard } from 'functions/copyToClipboard';
import { showToast } from 'react/toasts/showToast';

$.fn.elastic = function() {
	if(this.hasClass('elasticfied')) {
		return this;
	}
	this.addClass('elasticfied');
	return this.textareaAutoSize().trigger('keyup');
};

window.messageServiceWorker = function(data) {
	if(navigator.serviceWorker && navigator.serviceWorker.controller) {
		return new Promise(function(resolve, reject) {
			// Create a Message Channel
			const messageChannel = new MessageChannel();

			// Handler for recieving message reply from service worker
			messageChannel.port1.onmessage = function(event) {
				if(event.data.error) {
					reject(event.data.error);
				}
				else {
					resolve(event.data);
				}
			};

			navigator.serviceWorker.controller.postMessage(JSON.parse(JSON.stringify(data)), [messageChannel.port2]);
		});
	}
	return Promise.resolve('Service Workers Not Supported');
};
BrowserNotification.messageServiceWorker = window.messageServiceWorker;

window.copyToClipboard = copyToClipboard;
// For jQuery pages and PHP views: showToast({ content, kind: 'info' | 'warning' }).
window.showToast = showToast;


(function($) {
	var loadMoreElements = [];
	var windowScrollEvent = false;
	var activateOnce = function() {
		if(windowScrollEvent) {
			return;
		}
		windowScrollEvent = true;

		$(window).on('scroll', function() {
			if(!loadMoreElements.length) {
				return;
			}
			var window = $(this);
			loadMoreElements = $.grep(loadMoreElements, function(item, i) {
				if(!item.length) {
					return false;
				}
				try {
					if(window.scrollTop() + window.innerHeight() >= item.offset().top + item.outerHeight() - 160) {
						item.trigger('loadMore');
					}
					else {
					}
				}
				catch(error) {
					console.log('loadMore Error!');
					console.error(error);
					return false;
				}
				return true;
			});
		});
	};

	$.fn.loadMoreable = function(options = {}) {
		activateOnce();
		var table = $(this);
		if(table.data('loadMoreable')) {
			table.data('loadingMore', false);
			return false; // Already done
		}
		if(table.data('hasTabPane') === undefined) {
			let pane = table.closest('.tab-pane');
			if(pane.length) {
				table.data('hasTabPane', pane);
			}
		}
		if(options.loadMoreTable) {
			table.data('load_more_table', options.loadMoreTable);
		}
		if(options.parent) {
			table.data('loadMoreableParent', options.parent);
			options.parent.on('scroll.loadMoreable', function() {
				if(options.parent.scrollTop() + options.parent.innerHeight() >= table.position().top + table.outerHeight() - 160) {
					table.trigger('loadMore');
				}
			});
		}
		else {
			loadMoreElements.push($(this));
		}
		table.data('loadMoreable', true);
		table.on('loadMore', function() {
			var loadMoreUrl;
			if(table.data('loadingMore')) {
				return;
			}
			if(table.data('hasTabPane')) {
				if(!table.data('hasTabPane').hasClass('active')) {
					return;
				}
			}
			table.data('loadingMore', true);

			if(table.data('load_more_url')) {
				loadMoreUrl = table.data('load_more_url');
			}
			else {
				var last = table.find('.load_more:last');
				if(last.length) {
					loadMoreUrl = last.attr('href');
				}
			}
			var reset = function() {
				table.data('loadingMore', false);
				table.removeClass('loading_more');
			};
			if(!loadMoreUrl) {
				return;
			}
			table.addClass('loading_more');
			let loadingElement = table.findCache('.loading_more_shower');
			loadingElement.appendTo(table);

			Request.get(loadMoreUrl).then(function(response) {
				if(response.success) {
					if(response.html) {
						var html = $($.trim(response.html));
						var newTable;
						if(html.is(table.data('load_more_table'))) {
							newTable = html;
						}
						else {
							newTable = html.find(table.data('load_more_table'));
						}
						if(!newTable.length) {
							console.error('Load more: the response has no ' + table.data('load_more_table') + ' table');
							reset();
							return;
						}
						var newLoadMoreUrl = newTable.data('load_more_url');
						table.attr('data-load_more_url', newLoadMoreUrl).data('load_more_url', newLoadMoreUrl);

						var appendData = html.find(table.data('load_more_data_elements'));
						table.append(appendData);
						reset();
					}
				}
				table.removeClass('loading_more');

			}, () => {
				reset();
			});
		});
	};
})(jQuery);

(function(e) {
	e.fn.bindWithDelay = function(events, callback, delay = 300) {
		this.on(events, () => {
			const theArgs = arguments;
			this.data('bindWithDelayTimer') && clearTimeout(this.data('bindWithDelayTimer'));
			this.data('bindWithDelayTimer', setTimeout(() => {
				callback.apply(this, theArgs);
			}, delay));
		});
		return this;
	};
})(jQuery);

$.fn.serializeObject = function() {
	var data = {};
	$.each(this.serializeArray(), function(key, obj) {
		var a = obj.name.match(/(.*?)\[(.*?)\]/);
		if(a !== null) {
			var subName = new String(a[1]);
			var subKey = new String(a[2]);
			if(!data[subName]) {
				data[subName] = {};
			}
			if(data[subName][subKey]) {
				if($.isArray(data[subName][subKey])) {
					data[subName][subKey].push(obj.value);
				}
				else {
					data[subName][subKey] = {};
					data[subName][subKey].push(obj.value);
				}
			}
			else {
				data[subName][subKey] = obj.value;
			}
		}
		else {
			var keyName = new String(obj.name);
			if(data[keyName]) {
				if($.isArray(data[keyName])) {
					data[keyName].push(obj.value);
				}
				else {
					data[keyName] = {};
					data[keyName].push(obj.value);
				}
			}
			else {
				data[keyName] = obj.value;
			}
		}
	});
	return data;
};

$(function() {
	$('.wall_posts').on('click', '.delete', function(e) {
		var result = confirm('Delete Wall Post?');
		return result;
	});

	$('.user_input, .autolinked').each(function() {
		var input = $(this);
		var result = Autolinker.link(input.html(), LadderLinker.autolinkerOptions);
		input.html(result);
	});
});

(function($) {
	$.fn.serializeArrayCsrf = function() {
		var csrf = { name: theSecretField, value: theSecret };
		var value = $(this).serializeArray();
		value.push(csrf);
		return value;
	};
})(jQuery);

var SiteEditor = {
	changeTimeout: null,
	editorSettings: {
		mode: 'none',
		plugins: 'image, autolink, link, anchor, code, lists, advlist, textcolor, colorpicker, autoresize, fullscreen',
		browser_spellcheck: true,
		gecko_spellcheck: true,
		image_advtab: true,
		tools: 'inserttable, image, code, preview',
		toolbar1: 'undo redo | link image | styleselect | bold italic underline | forecolor backcolor | bullist numlist outdent indent ',
		autoresize_max_height: 500,
		content_css: siteCssFiles,
		relative_urls: false,
		entity_encoding: 'raw',
		add_unload_trigger: false,
		remove_linebreaks: false,
		inline_styles: false,
		convert_fonts_to_spans: false,
		setup: function(editor) {
			editor.on('NodeChange', function(e) {
			}).on('change', function() {
				$(this.targetElm).trigger('change');
			});
		}
	},
	setEditors: function($elements) {
		$elements.each(function(i, editor) {
			var $editor = $(editor);
			$editor.tinymce(SiteEditor.editorSettings);
		});
	}

};
SiteEditor.setEditors($('.post-editor'));

$(function() {

	$.each($('.dynamic-posts'), function(i, topic) {
		new PostManager($(topic));
	});
});

/*!
 * jQuery Textarea AutoSize plugin
 * Author: Javier Julio
 * Licensed under the MIT license
 */
;(function($, window, document, undefined) {

	var pluginName = 'textareaAutoSize';
	var pluginDataName = 'plugin_' + pluginName;

	var containsText = function(value) {
		return (value.replace(/\s/g, '').length > 0);
	};

	function Plugin(element, options) {
		this.element = element;
		this.$element = $(element);
		this.init();
	}

	Plugin.prototype = {
		init: function() {
			var diff = parseInt(this.$element.css('paddingBottom')) +
				parseInt(this.$element.css('paddingTop')) +
				parseInt(this.$element.css('borderTopWidth')) +
				parseInt(this.$element.css('borderBottomWidth')) || 0;

			if(containsText(this.element.value)) {
				this.$element.height(this.element.scrollHeight - diff);
			}

			// keyup is required for IE to properly reset height when deleting text
			this.$element.on('input keyup', function(event) {
				var $window = $(window);
				var currentScrollPosition = $window.scrollTop();

				$(this)
					.height(0)
					.height(this.scrollHeight - diff);

				$window.scrollTop(currentScrollPosition);
			});
		}
	};

	$.fn[pluginName] = function(options) {
		this.each(function() {
			if(!$.data(this, pluginDataName)) {
				$.data(this, pluginDataName, new Plugin(this, options));
			}
		});
		return this;
	};

})(jQuery, window, document);

jQuery.fn.putCursorAtEnd = function() {

	return this.each(function() {

		// Cache references
		var $el = $(this),
			el = this;

		// Only focus if input isn't already
		if(!$el.is(':focus')) {
			$el.focus();
		}


		let atStart = false;
		// If this function exists... (IE 9+)
		if(typeof window.getSelection != 'undefined'
			&& typeof document.createRange != 'undefined') {
			var range = document.createRange();
			range.selectNodeContents(el);
			range.collapse(atStart);
			var sel = window.getSelection();
			sel.removeAllRanges();
			sel.addRange(range);
		}
		else if(typeof document.body.createTextRange != 'undefined') {
			var textRange = document.body.createTextRange();
			textRange.moveToElementText(el);
			textRange.collapse(atStart);
			textRange.select();
		}


		// Scroll to the bottom, in case we're in a tall textarea
		// (Necessary for Firefox and Chrome)
		this.scrollTop = 999999;

	});

};

/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
!function(a) {
	function f(a, b) {
		if(!(a.originalEvent.touches.length > 1)) {
			a.preventDefault();
			var c = a.originalEvent.changedTouches[0], d = document.createEvent('MouseEvents');
			d.initMouseEvent(b, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), a.target.dispatchEvent(d);
		}
	}

	if(a.support.touch = 'ontouchend' in document, a.support.touch) {
		var e, b = a.ui.mouse.prototype, c = b._mouseInit, d = b._mouseDestroy;
		b._touchStart = function(a) {
			var b = this;
			!e && b._mouseCapture(a.originalEvent.changedTouches[0]) && (e = !0, b._touchMoved = !1, f(a, 'mouseover'), f(a, 'mousemove'), f(a, 'mousedown'));
		}, b._touchMove = function(a) {
			e && (this._touchMoved = !0, f(a, 'mousemove'));
		}, b._touchEnd = function(a) {
			e && (f(a, 'mouseup'), f(a, 'mouseout'), this._touchMoved || f(a, 'click'), e = !1);
		}, b._mouseInit = function() {
			var b = this;
			b.element.bind({
				touchstart: a.proxy(b, '_touchStart'),
				touchmove: a.proxy(b, '_touchMove'),
				touchend: a.proxy(b, '_touchEnd')
			}), c.call(b);
		}, b._mouseDestroy = function() {
			var b = this;
			b.element.unbind({
				touchstart: a.proxy(b, '_touchStart'),
				touchmove: a.proxy(b, '_touchMove'),
				touchend: a.proxy(b, '_touchEnd')
			}), d.call(b);
		};
	}
}(jQuery);